export const key = process.env.REACT_APP_PUBLIC_RE_CAPTCHA_KEY
